export default __webpack_public_path__ + "static/media/AWARIA_KIOSKU.7745f48e.png";